import { Canvas } from "@react-three/fiber";
import { OrthographicCamera } from "@react-three/drei";
import * as THREE from "three";
import { ItemIcon } from "@/routes/(game)/shop/-components/ItemIcon";
import { MODEL_REGISTRY, type ModelType } from "@/components/RocketsOverlay";
import type { GachaPrizeItem } from "@/lib/types/api";
import { cn } from "@/lib/utils";

export function PrizeDisplay({
  prize,
  className,
}: {
  prize: GachaPrizeItem;
  className?: string;
}) {
  const modelId = prize.id as ModelType;
  const ModelComponent = MODEL_REGISTRY[modelId];

  if (ModelComponent) {
    return (
      <div className={cn("h-16 pointer-events-none", className)}>
        <Canvas style={{ pointerEvents: "none" }}>
          <OrthographicCamera makeDefault position={[0, 0, 1000]} zoom={1} />
          <ambientLight position={[0, 0, 10]} intensity={3} />
          <directionalLight
            position={[0, THREE.MathUtils.degToRad(40), 0]}
            intensity={12}
          />
          <ModelComponent rotation={0} />
        </Canvas>
      </div>
    );
  }

  return <ItemIcon item={prize} className="w-14 h-auto" />;
}
